import { isInternalPath } from '@/shared/patterns/navigation';

// Destinos que a Início mostra agora (cartões da mesa, favoritos, recentes e o Dashboard do pulso). A ação
// `home.open` só abre um destes: o agente não leva a pessoa para um caminho inventado (como o mapa, R2).

const published = new Set<string>();

/** Registra destinos internos mostrados na Início. */
export function allowHomeHrefs(hrefs: Iterable<string>): void {
  for (const href of hrefs) if (isInternalPath(href)) published.add(href);
}

export function isHomeHref(href: string): boolean {
  return published.has(href);
}

/** Só teste: começa sem destino publicado. */
export function resetHomeHrefs(): void {
  published.clear();
}
